const closeButtonLabel = "Cerrar";
const esCL = {
  closeButtonLabel
};
export {
  closeButtonLabel,
  esCL as default
};
